if (!customElements.get('mobile-purchase-bar')) {
  customElements.define(
    'mobile-purchase-bar',
    class MobilePurchaseBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.submitButton = this.querySelector('[data-mobile-purchase-submit]');
        this.label = this.querySelector('[data-mobile-purchase-label]');
        this.price = this.querySelector('[data-mobile-purchase-price]');
        this.productInfo = this.closest('product-info');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.ticking = false;

        this.handleClick = this.handleClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.sync = this.sync.bind(this);

        this.submitButton?.addEventListener('click', this.handleClick);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });

        // Watch only the original Shopify purchase controls.
        // Do NOT observe the entire <product-info> element because this
        // mobile bar lives inside it. Observing the parent caused sync()
        // to observe its own DOM updates and repeatedly fire, which could
        // lock up product pages and interfere with images/cart actions.
        this.observer = new MutationObserver(this.sync);

        const mainButton = this.mainButton;
        if (mainButton) {
          this.observer.observe(mainButton, {
            subtree: true,
            childList: true,
            attributes: true,
            characterData: true,
            attributeFilter: ['disabled', 'value', 'class'],
          });
        }

        const mainPrice = this.mainPrice;
        if (mainPrice) {
          this.observer.observe(mainPrice, {
            subtree: true,
            childList: true,
            characterData: true,
          });
        }

        this.sync();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.submitButton?.removeEventListener('click', this.handleClick);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.observer?.disconnect();
      }

      get mainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      get mainPrice() {
        return document.getElementById(`price-${this.sectionId}`);
      }

      handleClick() {
        const mainButton = this.mainButton;
        if (!mainButton || mainButton.disabled) return;
        mainButton.click();
      }

      handleScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.updateVisibility();
          this.ticking = false;
        });
      }

      updateVisibility() {
        const mainButton = this.mainButton;
        const shouldShow =
          this.mobileQuery.matches &&
          mainButton &&
          mainButton.getBoundingClientRect().bottom < 0;

        this.classList.toggle('is-visible', Boolean(shouldShow));
        this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }

      sync() {
        const mainButton = this.mainButton;
        if (!mainButton || !this.submitButton) return;

        this.submitButton.disabled = mainButton.disabled;
        this.submitButton.classList.toggle('is-loading', mainButton.classList.contains('loading'));
        this.submitButton.setAttribute('aria-disabled', mainButton.disabled ? 'true' : 'false');

        const mainLabel = mainButton.querySelector('span');
        if (mainLabel && this.label) this.label.textContent = mainLabel.textContent.trim();

        const mainPrice = this.mainPrice;
        if (mainPrice && this.price) this.price.innerHTML = mainPrice.innerHTML;

        this.updateVisibility();
      }
    }
  );
}
